<app-loader></app-loader>
<router-outlet></router-outlet>



<ng-template #childModal let-modal>
<!-- <div bsModal #childModal="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-child-name" [config]="{ backdrop: 'static' }">
  <div class="modal-dialog modal-md"> -->
    <div class="modal-content">
        <div class="modal-header">
            <h4 id="dialog-child-name" class="modal-title pull-left">Session about to expire</h4>            
        </div>
        <div class="modal-body">
         <!-- {{idleState}} -->
         Please click on the OK button to extend your session.
        </div>
        <div class="modal-footer">
            <div class="row">
                    <div class="col-sm-3"></div>
                    <div class="col-sm-6">
                        <button type="button" (click)="stay()" class="btn btn-block ok-list-button">OK</button>
                    </div>
                    <div class="col-sm-3"></div>
            </div>
        </div>
    </div>
  <!-- </div>
</div> -->
</ng-template>

